import { render, staticRenderFns } from "./ProjectSlider.vue?vue&type=template&id=1d69a07d&scoped=true&"
import script from "./ProjectSlider.vue?vue&type=script&lang=ts&"
export * from "./ProjectSlider.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectSlider.vue?vue&type=style&index=0&id=1d69a07d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d69a07d",
  null
  
)

export default component.exports